import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => {
  return {
    dialogPaper: {
      width: 444,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[16],
    },
    dialogText: {
      color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "150%",
      letterSpacing: "0.15px",
    },
    calenderContainer: {
      display: "flex",
      marginTop: "24px",
      flexDirection: "column",
      gap: "3px",
    },
    dialogContent: {
      paddingBottom: theme.spacing(2.5),
    },
    dialogActions: {
      padding: theme.spacing(1),
      justifyContent: "flex-end",
      gap: theme.spacing(1),
    },
  };
});
